import React, { useState, useEffect } from "react";
import "../css/NoNetworkStatusModal.css";
import { Modal } from "@mui/material";

const NoNetworkStatusModal = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  const handleRetry = () => {
    if (navigator.onLine) {
      setIsOffline(false);
    }
  };

  return (
    <Modal className="no-network-popup" open={isOffline} onOk={handleRetry}>
      <div className="no-network-popup-content">
        <p>Check your internet connection and try again.</p>
        <button onClick={handleRetry}>Retry</button>
      </div>
    </Modal>
  );
};

export default NoNetworkStatusModal;
